//#region imports
import customAxios from '../../utils/customAxios';
import React, { useState, useEffect } from 'react';

import { DataGridPro, GridPagination } from '@mui/x-data-grid-pro';

import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

import { Stack } from '@mui/system';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons';

import { useTranslationHook } from '../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../globalVar';
import { useTableLocale } from '../../hooks/useTableLocale';

library.add(
  fas,
  faCalendarPlus,
  faBan,
  faChalkboardUser,
  faHandshakeAngle,
  faStreetView,
  faScrewdriverWrench,
  faFlagCheckered,
  faSquarePlus,
  faPersonCirclePlus,
  faXmark,
  faThumbsUp,
  faSkullCrossbones,
  faPersonWalkingArrowRight,
  faCheckDouble
);

//#endregion

export const VisitsBySiteAxios = () => {
  const [visitsBySiteData, setVisitsBySiteData] = useState([]);

  const [visitsNAData, setVisitsNAData] = useState([]);
  const [visitsAData, setVisitsAData] = useState([]);
  const [visitsCData, setVisitsCData] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });

  const {
    dashboardDTVisitsClient,
    dashboardDTVisitsSite,
    dashboardDTVisitsVType,
    dashboardDTVisitsTech,
    noVisitsString,
    dashboardDTVisitsVNA,
    dashboardDTVisitsVC,
    dashboardDTVisitsVA,
    dashboardDTVisitsVCa,
    dashboardDTVisitsTitle,
  } = useTranslationHook();

  const generalEndpoint = `${GlobalVariables.getURL()}techsDashboard`;

  const getGeneralData = async () => {
    try {
      const response = await customAxios.get(generalEndpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const visitsNAData = response.data['Servicios Sin Tecnico Asignado'].map(
        (visitNA) => {
          return {
            id: visitNA.visit_id,
            ...visitNA,
          };
        }
      );
      const visitsAData = response.data['Detalles de Servicios Asignados'].map(
        (visitA) => {
          return {
            id: visitA.visit_id,
            ...visitA,
          };
        }
      );
      const visitsCData = response.data['Servicios Cancelados'].map(
        (visitC) => {
          return {
            id: visitC.visit_id,
            ...visitC,
          };
        }
      );
      setVisitsNAData(visitsNAData);
      setVisitsAData(visitsAData);
      setVisitsCData(visitsCData);
    } catch (error) {
      console.log(error);
    }
  };

  const id = localStorage.getItem('siteIdOfCluster');

  const endpoint = `${GlobalVariables.getURL()}visitsFromSite/${id}`;

  const getData = async () => {
    setIsLoading(true);

    try {
      const response = await customAxios.get(endpoint, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      });
      const visitsBySiteData = response.data['Servicios Por Tienda'].map(
        (visit) => {
          return {
            id: visit.visit_id,
            ...visit,
          };
        }
      );
      setVisitsBySiteData(visitsBySiteData);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
    getGeneralData();
  }, []);

  useEffect(() => {
    // No necesitas hacer nada en este efecto.
  }, [isLoading]);

  function CustomFooterTrackingV() {
    return (
      <Box
        display='flex'
        flexDirection='row'
        flexWrap='wrap'
        alignItems='left'
        justifyContent='flex-start'
        marginLeft={1}
        marginRight={1}
        marginTop={2}
        marginBottom={2}
        height='50%'
        width='50%'
      >
        <div style={{ flexBasis: '100%' }}>
          <span>
            <strong>{dashboardDTVisitsTitle}</strong>
          </span>
        </div>
        <div style={{ flexBasis: '50%' }}>
          <span>
            <FontAwesomeIcon icon={faLocationDot} color='red' />{' '}
            {dashboardDTVisitsVNA}
          </span>
        </div>
        <div style={{ flexBasis: '50%' }}>
          <span>
            <FontAwesomeIcon icon={faLocationDot} color='green' />{' '}
            {dashboardDTVisitsVC}
          </span>
        </div>
        <div style={{ flexBasis: '50%' }}>
          <span>
            <FontAwesomeIcon icon={faLocationDot} color='#ff8000' />{' '}
            {dashboardDTVisitsVA}
          </span>
        </div>
        <div style={{ flexBasis: '50%' }}>
          <span>
            <FontAwesomeIcon icon={faLocationDot} color='black' />{' '}
            {dashboardDTVisitsVCa}
          </span>
        </div>
      </Box>
    );
  }

  const dataWithStatus = visitsBySiteData.map((row) => {
    const isVisitA = visitsAData.some((visit) => visit.visit_id === row.id);
    const isVisitNA = visitsNAData.some((visit) => visit.visit_id === row.id);
    const isVisitC = visitsCData.some((visit) => visit.visit_id === row.id);
    let status;

    if (row.visit_status === 'Técnico ha terminado') {
      status = 'isVisitCo';
    } else if (isVisitC) {
      status = 'isVisitCa';
    } else if (isVisitA) {
      status = 'isVisitA';
    } else if (isVisitNA) {
      status = 'isVisitNA';
    }

    return { ...row, status };
  });

  // Columnas
  const visitsBySiteColumns = [
    {
      field: 'id',
      headerName: 'ID',
      sortable: false,
      width: 60,
    },
    {
      field: 'client',
      headerName: dashboardDTVisitsClient,
      sortable: false,
      width: 150,
    },
    {
      field: 'site',
      headerName: dashboardDTVisitsSite,
      sortable: false,
      width: 200,
      renderCell: (params) => {
        const isVisitA = visitsAData.some(
          (visit) => visit.visit_id === params.id
        );
        const isVisitNA = visitsNAData.some(
          (visit) => visit.visit_id === params.id
        );
        const isVisitC = visitsCData.some(
          (visit) => visit.visit_id === params.id
        );

        const fillColor =
          params.row.visit_status === 'Técnico ha terminado'
            ? 'green'
            : isVisitC
            ? 'black'
            : isVisitA
            ? '#ff8000'
            : isVisitNA
            ? 'red'
            : 'gray';

        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <FontAwesomeIcon
              icon={faLocationDot}
              style={{
                color: fillColor,
                fontSize: '1.5rem',
                marginRight: '5px',
              }}
            />{' '}
            <span>{params.row.site}</span>
          </div>
        );
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
      hideable: false,
      sortComparator: (v1, v2) => {
        const order = {
          isVisitNA: 1,
          isVisitA: 2,
          isVisitCo: 3,
          isVisitCa: 4,
        };

        return order[v1] - order[v2];
      },
    },
    {
      field: 'tech_name',
      headerName: dashboardDTVisitsTech,
      sortable: false,
      width: 250,
    },
    {
      field: 'visit_type',
      headerName: dashboardDTVisitsVType,
      sortable: false,
      width: 180,
    },
  ];

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    visit_type: false,
    status: false,
  });

  const locale = useTableLocale();

  return (
    <>
      <DataGridPro
        localeText={locale.components.MuiDataGrid.defaultProps.localeText}
        loading={isLoading}
        initialState={{
          sorting: {
            sortModel: [{ field: 'status', sort: 'asc' }],
          },
        }}
        rows={dataWithStatus}
        columns={visitsBySiteColumns}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) => {
          setColumnVisibilityModel(newModel);
        }}
        onRowClick={(e) => {
          navigate(`/visits/details/${e.id}`);
        }}
        pagination
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        slots={{
          noRowsOverlay: () => (
            <Stack height='100%' alignItems='center' justifyContent='center'>
              {noVisitsString}
            </Stack>
          ),
          footer: () => (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: 'fit-content',
              }}
            >
              <CustomFooterTrackingV />
              <GridPagination />
            </div>
          ),
        }}
      />
    </>
  );
};
